(function($, undefined) {
	'use strict';
	var utils;
	var form;
	
	var demoCall = function () {
		processForm({
			t: this,
			formClass: '.demo-share-form',
			popupClass: '.demo-share-form-popup',
			fileName: 'demo-share'
		});
	};
	
	var saveCall = function () {
		processForm({
			t: this,
			formClass: '.save-share-form',
			popupClass: '.save-share-form-popup',
			fileName: 'save-share'
		});
	};
	
	var auditionCall = function () {
		var name = $(this).attr('data-extra');
		processForm({
			t: this,
			formClass: '.audition-share-form',
			popupClass: '.audition-share-form-popup',
			fileName: 'audition-share',
			extra: name
		});
	};
	
	var subscriptionUpdateCall = function () {
		processForm({
			t: this,
			formClass: '.send-message-upgrade-package-form',
			popupClass: '.send-message-upgrade-package-form-popup',
			fileName: 'upgrade-package-share'
		});
	};
	
	var processForm = function (data) {
		var t = $(data.t);
		var currForm = t.closest(data.formClass);
		var currPopup = currForm.closest(data.popupClass);
		
		form.validateForm(currForm);
		
		if (!currForm.hasClass('has-error')) {
			currPopup.addClass('is-processing');
			
			var lang = $('html').attr('lang');
			var subject = $('input[name="subject"]', currForm).val().trim();
			var urlToShare = $('input[name="urlToShare"]', currForm).val().trim();
			var name = $('.form-input[name="name"]', currForm).val().trim();
			var fromEmail = $('.form-input[name="fromEmail"]', currForm).val().trim();
			var sendEmail = $('.form-input[name="sendEmail"]', currForm).val().split(',');
			var message = $('.form-input[name="message"]', currForm).val().trim();
			var copy = $('.form-check-input[name="copy"]', currForm).is(':checked');
			
			
			var count = sendEmail.length;
			var doneCount = 0;
			
			if (copy) {
				count++;
			}
			
			for (var i = sendEmail.length - 1; i >= 0; i--) {
				utils.sendEmail(sendEmail[i].trim(), subject, message, data.fileName + "-" + lang, {"field1": name, "field2": fromEmail, "field3":urlToShare, "field4":data.extra}, function(response) {
					console.log(data.fileName + ' : ' + response);
					doneCount++;
					
					if (doneCount === count) {
						showSuccess(currPopup);
					}
				});
			}
			
			if (copy) {
				utils.sendEmail(fromEmail, subject, message, data.fileName + "-" + lang, {"field1": name, "field2": fromEmail, "field3":urlToShare}, function(response) {
					console.log(data.fileName + ' : ' + response);
					doneCount++;
					
					if (doneCount === count) {
						showSuccess(currPopup);
					}
				});
			}
		}
	};
	
	var showSuccess = function (currPopup) {
		currPopup.removeClass('is-processing');
		$('.popup-close-btn', currPopup).trigger('click');
		
		if (!$('body').hasClass('is-signed-in')) {
			$('.form-input[name="name"]').val('');
			$('.form-input[name="fromEmail"]').val('');
		}
		
		$('.form-input[name="name"]').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-input[name="fromEmail"]').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		
		$('.form-input[name="sendEmail"]').val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-input[name="message"]').val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-check-input[name="copy"]').prop('checked', false);
	};

	var updateSaveType = function () {
		var select = $(this);
		var form = $(select).closest('.fieldset');
		var upload = $('.form-item-upload', form);
		var gendataId = $('input[name="gendataId"]', form).val();
		var mediaId = $('input[name="userMediaId"]', form).val();

		if(select.val() == 'customImage') {
			upload.removeClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'true',
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
				}
			});
		}
		else if(select.val() == 'profileImage') {
			upload.addClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'true',
					field5: '/static/uploaded/Profile/' + mediaId + '-main.jpg',
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
				}
			});
		}
		else {
			upload.addClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'false',
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
				}
			});
		}
	};

	var changeSavePic = function () {
		var t = $(this);
		var form = $(t).closest('.fieldset');
		var gendataId = $('input[name="gendataId"]', form).val();
		var files = t[0].files;
		var size = files[0].size;

		console.log('size : ' + size);

		if (files !== undefined) {
			if (size <= 1048576) { // 1MB
				// $('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('image', files[i]);
						data.append('customLabel', 'save');
						data.append('directory', 'Save');
						data.append('ajax', 'true');

						$.ajax({
							url: '/action/uploadCroppedImage',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function (response) {
								console.log(response);
								var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
								console.log('file: ' + newFileId);
								
								var newDate = new Date();
								
								$.ajax({
									url: '/action/manageGenData',
									cache: false,
									data: {
										id: gendataId,
										field4: 'true',
										field5: '/static/uploaded/Save/' + newFileId + '-save.jpg',
										ajax: true
									},
									success: function (genResponse) {
										// var newScriptId = genResponse.substring('success-'.length);
										console.log('Gendata: ' + genResponse);
										
										// fileCtn.removeClass('is-processing');
										// form.resetUpload(file);
										
										// callback(newFileId, ext, filename, newScriptId);
									} 
								});
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};

	var init = function() {
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;
		
		$('body').on('click', '.demo-share-form-submit', demoCall);
		$('body').on('click', '.save-share-form-submit', saveCall);
		$('body').on('click', '.audition-share-form-submit', auditionCall);
		$('body').on('click', '.send-message-upgrade-package-form-submit', subscriptionUpdateCall);
		$('body').on('change', '[name="save-share-form-type"]', updateSaveType);
		$('body').on('change', '[name="save-share-custom-pic"]', changeSavePic);
	};
	
	$(init);

})(jQuery);

